import React, { useCallback, useEffect, useMemo } from 'react'
import { Form } from 'react-bootstrap';
import { useDropzone } from 'react-dropzone'
import { useImmer } from 'use-immer';
import objectHelpers from '../../utilities/objectHelpers';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { ConditionalRender } from '.';

const limitStringLen = (str, maxLength = 20) => {
    //const re = /(?:\.([^.]+))?$/;
    const split = str.split('.');
    const ext = split.pop();
    let tmpStr = split.join();
    if (tmpStr.length > maxLength) {

        tmpStr = tmpStr.slice(0, (maxLength / 2)) + '...' + tmpStr.slice(tmpStr.length - (maxLength / 2) + 1);
        return tmpStr + '.' + ext;
    }
    return str;
}

const FileSelector = (props) => {
    //const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });  
    const errors = objectHelpers.get(props.formHandler.errors, props.name);
    const [files, setFiles] = useImmer([]);

    useEffect(() => {
        props.formHandler.setFieldValue(props.name, files, true)
    }, [files])

    const onDrop = useCallback(acceptedFiles => {
        setFiles(draftArray => {
            let tmpArray = Array.from(draftArray);
            tmpArray = tmpArray.concat(acceptedFiles);
            return tmpArray;
        })
        //let tmpArray = Array.from(files);
        //window.alert(JSON.stringify(tmpArray, null, 2));
        //tmpArray = tmpArray.concat(acceptedFiles);
        //window.alert(JSON.stringify(tmpArray, null, 2));
        //setFiles(tmpArray)
    }, [])

    const {
        getRootProps,
        getInputProps,
        isDragActive,
        isDragAccept,
        isDragReject
    } = useDropzone({ onDrop }); // , accept: 'image/*'

    const removeFile = (idx) => {
        // remove from accepted files
        setFiles(draft => {
            draft.splice(idx, 1);
        })
    }

    const containerClass = useMemo(() => {
        let className = "file-selector mr-auto";
        if (isDragActive && !isDragAccept && !isDragReject) { className = className + ' file-selector-active' }
        if (isDragAccept && !isDragReject) { className = className + ' file-selector-accepted' }
        if (isDragReject) { className = className + ' file-selector-reject' }
        return className;
    }, [isDragActive, isDragReject, isDragAccept])

    return (
        <>
            <Form.Label disabled={props.disabled} className={props.label ?? "d-none"}>{props.label}</Form.Label>
            <div className="d-flex align-items-top">
                <div {...getRootProps()} className={containerClass}>
                    <Form.Control
                        disabled={props.disabled}
                        name={props.name}
                        {...getInputProps()}
                    />
                    {
                        isDragActive ?
                            <p>Drop the files here ...</p> :
                            <p>Drag 'n' drop some files here, or click to select files</p>
                    }
                </div>

            </div>
            <ConditionalRender visible={files.length > 0}>
                <div className="d-flex flex-wrap small text-muted">
                    {
                        files.map((file, idx) => {
                            return <div className="text-nowrap pr-2 pb-1" key={idx}>
                                <FontAwesomeIcon
                                    icon={faTrashAlt}
                                    className="text-danger givemethefinger"
                                    onClick={() => removeFile(idx)}
                                /> {limitStringLen(file.name, 20)}
                            </div>
                        })
                    }
                </div>
            </ConditionalRender>
            <Form.Control.Feedback disabled={props.disabled} type="invalid">{errors}</Form.Control.Feedback>
        </>
    )
}

export default FileSelector;